"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const react_router_1 = require("react-router");
const Auth_1 = require("../../../../actions/Auth");
const Button_1 = __importDefault(require("../../../input/Button"));
const FormErrors_1 = __importDefault(require("../../../pageParts/FormErrors"));
const CaptchaComponent_1 = __importDefault(require("../../../captcha/CaptchaComponent"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const RegisterForm = ({ withCaptcha = false, withEmailOnly = false, introductionText }) => {
    const { t } = (0, react_i18next_1.useTranslation)('auth');
    const dispatch = (0, react_redux_1.useDispatch)();
    const submitButtonRef = react_1.default.useRef(null);
    const navigate = (0, react_router_1.useNavigate)();
    const location = (0, react_router_1.useLocation)();
    const isAuthenticated = (0, react_redux_1.useSelector)((state) => state.auth.isAuthenticated);
    const register = (0, react_redux_1.useSelector)((state) => state.auth.register);
    const [formState, setFormState] = react_1.default.useState({
        username: '',
        email: '',
        password: '',
        passwordConfirmation: '',
        captchaValid: false,
        captchaReloadKey: 0
    });
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormState((prev) => (Object.assign(Object.assign({}, prev), { [name]: name === 'email' ? value.replaceAll(' ', '') : value })));
    };
    const validateForm = () => {
        if (!withEmailOnly && !formState.username) {
            return 'auth:missingUsername';
        }
        if (!formState.email) {
            return 'auth:missingEmail';
        }
        if (!formState.password) {
            return 'auth:missingPasswordRegister';
        }
        if (formState.password !== formState.passwordConfirmation) {
            return 'auth:passwordsDoNotMatch';
        }
        if (formState.password.length < 8) {
            return { text: 'auth:passwordMustHaveAtLeastNCharacters', params: { n: '8' } };
        }
        if (!(0, LodashExtensions_1._isEmail)(formState.email)) {
            return 'auth:invalidEmail';
        }
        if (withCaptcha && formState.captchaValid !== true) {
            return 'auth:captchaMismatch';
        }
        return undefined;
    };
    const handleSubmit = () => {
        const error = validateForm();
        if (error) {
            setFormState((prev) => (Object.assign(Object.assign(Object.assign({}, prev), { error }), (withCaptcha ? { captchaReloadKey: prev.captchaReloadKey + 1 } : {}))));
            return;
        }
        setFormState((prev) => (Object.assign(Object.assign({}, prev), { error: undefined })));
        dispatch((0, Auth_1.startRegisterWithPassword)({
            username: withEmailOnly ? formState.email : formState.username,
            email: formState.email,
            generatedPassword: null,
            password: formState.password
        }, location, navigate));
    };
    const handleEnterKeyUp = (e) => {
        var _a;
        // Submit form on 'Enter' inside the element
        if (e.key === 'Enter') {
            (_a = submitButtonRef.current) === null || _a === void 0 ? void 0 : _a.click();
        }
    };
    return (react_1.default.createElement("form", { className: "apptr__form apptr__form-auth", onSubmit: (e) => e.preventDefault() },
        react_1.default.createElement("div", { className: "apptr__form-label-container center" },
            react_1.default.createElement("div", { className: "apptr__form__label-standalone no-question" },
                react_1.default.createElement("p", null, introductionText || t('auth:pleaseEnterLoginCredentials'))),
            formState.error && react_1.default.createElement(FormErrors_1.default, { errors: [formState.error] }),
            register && !isAuthenticated && react_1.default.createElement(FormErrors_1.default, { errors: ['auth:usernameOrEmailAlreadyExists'] })),
        react_1.default.createElement("div", { className: "apptr__form-container question-empty" },
            react_1.default.createElement("div", { className: "apptr__form-input-container" },
                react_1.default.createElement("label", { htmlFor: "email", className: "_flex" }, t('auth:Email')),
                react_1.default.createElement("input", { name: "email", id: "email", type: "text", inputMode: "email", className: "apptr__form-input apptr__form-input-string apptr__input apptr__input-string", autoFocus: true, value: formState.email, onChange: handleInputChange }))),
        !withEmailOnly && (react_1.default.createElement("div", { className: "apptr__form-container question-empty" },
            react_1.default.createElement("div", { className: "apptr__form-input-container" },
                react_1.default.createElement("label", { htmlFor: "username", className: "_flex" }, t('auth:Username')),
                react_1.default.createElement("input", { name: "username", id: "username", type: "text", className: "apptr__form-input apptr__form-input-string apptr__input apptr__input-string", value: formState.username, onChange: handleInputChange })))),
        react_1.default.createElement("div", { className: "apptr__form-container question-empty" },
            react_1.default.createElement("div", { className: "apptr__form-input-container" },
                react_1.default.createElement("label", { htmlFor: "password", className: "_flex" }, t('auth:Password')),
                react_1.default.createElement("input", { name: "password", id: "password", type: "password", className: "apptr__form-input apptr__form-input-string apptr__input apptr__input-string _input-password", value: formState.password, onChange: handleInputChange }))),
        react_1.default.createElement("div", { className: "apptr__form-container question-empty" },
            react_1.default.createElement("div", { className: "apptr__form-input-container" },
                react_1.default.createElement("label", { htmlFor: "passwordConfirmation", className: "_flex" }, t('auth:PasswordConfirmation')),
                react_1.default.createElement("input", Object.assign({ name: "passwordConfirmation", id: "passwordConfirmation", type: "password", className: "apptr__form-input apptr__form-input-string apptr__input apptr__input-string _input-password", value: formState.passwordConfirmation, onChange: handleInputChange }, (withCaptcha ? {} : { onKeyUp: handleEnterKeyUp }))))),
        withCaptcha && (react_1.default.createElement("div", { className: "apptr__form-container question-empty" },
            react_1.default.createElement(CaptchaComponent_1.default, { onCaptchaValid: (isValid, _captchaValue) => 
                // FIXME Consider doing something about the captcha
                // value, like sending to the backend for validation
                // if the captcha components supports it
                setFormState((prev) => (Object.assign(Object.assign({}, prev), { captchaValid: isValid }))), reloadKey: formState.captchaReloadKey }))),
        react_1.default.createElement(Button_1.default, { type: "submit", isVisible: true, onClick: handleSubmit, inputRef: submitButtonRef, label: t(['transition:auth:Register', 'auth:Register']) })));
};
exports.default = RegisterForm;
//# sourceMappingURL=RegisterForm.js.map